<template>
  <div>
    <p>状态: {{ status }}</p>
    <ul>
      <li v-for="(msg, i) in messages" :key="i">{{ msg }}</li>
    </ul>
    <input v-model="inputMsg" @keyup.enter="send" placeholder="输入消息" />
    <button @click="send">发送</button>
    <button @click="close">断开</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      socket: null,
      status: '未连接',
      messages: [],
      inputMsg: '',
      userId: 'admin' // 从登录信息获取，例如 this. $ store.state.user.userId
    }
  },
  mounted() {
    this.connect()
  },
  beforeDestroy() {
    this.close()
  },
  methods: {
    connect() {
      // 注意：RuoYi 后端默认运行在 8080 端口（不是 8088！）
      const url = `ws://127.0.0.1:8088/websocket/${this.userId}`
      this.socket = new WebSocket(url)

      this.socket.onopen = () => {
        this.status = '已连接'
        console.log('WebSocket 连接成功')
      }

      this.socket.onmessage = (event) => {
        this.messages.push(event.data)
      }

      this.socket.onclose = () => {
        this.status = '已断开'
        console.log('WebSocket 连接关闭')
      }

      this.socket.onerror = (error) => {
        console.error('WebSocket 错误', error)
        this.status = '连接失败'
      }
    },
    send() {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(this.inputMsg)
        this.inputMsg = ''
      } else {
        this. $alert('WebSocket 未连接')
      }
    },
    close() {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
    }
  }
}
</script>